import {
  ChangeBuyerInformationPersonBackToSavedBuyerPerson,
  CreateTicketHolderBuyerPerson,
  SetBuyerPrefill,
  SetFormFields
} from '@core/data-access/models/form/form-store.model';
import {
  SetCreateTicketHolderFormFields,
  SetSavedTicketHolderFormFields
} from '@core/features/account/features/saved-ticket-holders/models/saved-ticket-holders.store.model';
import {
  SetBuyerBillingAddressFormFields,
  SetBuyerInformationFormFields
} from '@core/features/buyer-information/models/buyer-information-store.model';
import { SetBuyerQuestionnaireFormFields } from '@core/features/buyer-questionnaire/models/buyer-questionnaire-store.model';
import {
  SetTicketHolderFormFields,
  SetTicketHolderQuestionnaireFormFields
} from '@core/features/ticket-assignment/models/ticket-assignment-store.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const FormFieldSyncActions = createActionGroup({
  source: 'Form field sync',
  events: {
    'Set form fields': props<SetFormFields>(),
    'Set buyer information form fields': props<SetBuyerInformationFormFields>(),
    'Set buyer billing address form fields': props<SetBuyerBillingAddressFormFields>(),
    'Set buyer questionnaire form fields': props<SetBuyerQuestionnaireFormFields>(),
    'Set ticket holder form fields': props<SetTicketHolderFormFields>(),
    'Set ticket holder questionnaire form fields': props<SetTicketHolderQuestionnaireFormFields>(),
    'Set saved ticket holder form fields': props<SetSavedTicketHolderFormFields>(),
    'Set create ticket holder form fields': props<SetCreateTicketHolderFormFields>()
  }
});

export const BuyerFormsSyncActions = createActionGroup({
  source: 'Buyer forms sync',
  events: {
    'Set buyer information form prefill': props<SetBuyerPrefill>(),
    'Set buyer person and form fields on saved buyer ticket holder updated': emptyProps(),
    'Create ticket holder buyer person': props<CreateTicketHolderBuyerPerson>(),
    'Change buyer information person back to saved buyer person':
      props<ChangeBuyerInformationPersonBackToSavedBuyerPerson>()
  }
});
